export default __webpack_public_path__ + "static/media/Shri Thanedar.eab6176d.jpg";